/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import cx from 'classnames';

import { AffiliateType, isPartnerPng, isPartnerSvg } from './LogoAffiliate.helpers';

import styles from './LogoAffiliate.module.scss';

type LogoAffiliate = {
  affiliate: AffiliateType;
  className?: string;
  element?: React.ElementType;
}

export const LogoAffiliate = ({
  affiliate,
  className,
  element: Element = 'div',
  ...p
}: LogoAffiliate) => {
  const detectExtension = () => {
    if (isPartnerSvg(affiliate)) {
      return '.svg';
    }

    if (isPartnerPng(affiliate)) {
      return '.png';
    }

    return '';
  };

  const inlineStyles = {
    '--affiliate-bg': `url(/affiliatesLogos/${affiliate}${detectExtension()})`,
  } as React.CSSProperties;

  return (
    <Element
      className={cx(className, styles.logoAffiliate, styles[affiliate])}
      style={inlineStyles}
      {...p}
    />
  );
};
